var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online-indicator",class:{'status-online': _vm.online}},[(_vm.name != undefined)?_c('span',{staticClass:"online-indicator__status"}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }